/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ style: NonNullable<unknown> }} Caption_Style_UpdatedInputs */



/**
* | output |
* | --- |
* | "Caption style updated to {style}" |
*
* @param {Caption_Style_UpdatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_style_updated = /** @type {((inputs: Caption_Style_UpdatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_Style_UpdatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Style de sous-titrage mis à jour : ${i?.style}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Bildunterschriftenstil auf ${i?.style} aktualisiert`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Stile didascalia aggiornato a ${i?.style}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Стиль подписи обновлен до ${i?.style}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Estilo de subtítulo actualizado a ${i?.style}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`标题样式已更新为${i?.style}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`キャプションのスタイルが ${i?.style} に更新されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`कैप्शन शैली को ${i?.style} में अपडेट किया गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Estilo da legenda atualizado para ${i?.style}`)
	return /** @type {LocalizedString} */ (`Caption style updated to ${i?.style}`)
});